
//Players list
const players = [
    {
      id: 1,
      name: "Erling Haaland",
      team:"Manchester City",
      nationality:"Norvégien",
      jerseyNumber:9,
      age:23,
      image: "./img/haland.png",
    },
    {
      id: 2,
      name: "Kylian Mbappé",
      team:"PSG",
      nationality:"Frensh",
      jerseyNumber:10,
      age:22,
      image: "./img/mbape.png",
    },
    {
      id: 3,
      name: "Toni Kroos ",
      team:"Real Madrid",
      nationality:"Allemand ",
      jerseyNumber:8,
      age:33,
      image: "./img/kros.png",
    },
    {
      id: 4,
      name: "Karim Benzema",
      team:"Ittihad Club",
      nationality:"Frensh",
      jerseyNumber:14,
      age:35,
      image: "./img/benzima.png",
    },
  ];

  export default players;